import {
  FETCH_USER_PROFILE,
  FETCH_USER_ACCOUNT
} from './types';
  
export default function(state = {}, action) {
  
  switch (action.type) {
    case FETCH_USER_PROFILE:
      return { ...state, ...action.payload };
    case FETCH_USER_ACCOUNT:
      return { ...state, ...action.payload };
    default:
      return state;
  }

}


// WEBPACK FOOTER //
// ./src/data/profile/reducer.js